import React, { lazy, Suspense } from 'react';

// Lazy load ContactForm to reduce bundle size and defer Supabase loading
const ContactForm = lazy(() => import('@/components/ContactForm').then(module => ({ default: module.ContactForm })));

interface LazyContactFormProps {
  isOpen: boolean;
  onClose: () => void;
}

const LazyContactForm: React.FC<LazyContactFormProps> = (props) => (
  <Suspense fallback={null}>
    <ContactForm {...props} />
  </Suspense>
);

export { LazyContactForm as ContactForm };